import { Component, OnInit, OnDestroy, OnChanges, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'pershing-grid-page-navigator',
    templateUrl: 'pershing-grid-page-navigator.component.html'
})

export class PershingGridPageNavigatorComponent implements OnInit, OnDestroy, OnChanges {
    @Output() onPageChanged = new EventEmitter();
    @Input() totalRowCount: number = 0;
    canNext: boolean = false;
    canPrevious: boolean = false;
    nextScrollKey: string = null;
    scrollKeyList: Array<string> = [];

    constructor () {}

    ngOnInit(): void {
        this.reset();
    }

    ngOnChanges(): void {
        if (this.totalRowCount === 0) {
            this.reset();
        }
    }

    previousPage (): void {
        let i = 0;
        while (i < 2) {
            if (this.scrollKeyList.length > 0) {
                this.scrollKeyList.pop();
            }
            i = i + 1;
        }

        this.nextScrollKey = this.scrollKeyList.length > 0 ? this.scrollKeyList[this.scrollKeyList.length - 1] : '';
        this.onPageChanged.emit(this.nextScrollKey);
        this.disableControls();
    }

    nextPage (): void {
        this.onPageChanged.emit(this.nextScrollKey);
        this.disableControls();
    }

    reset(): void {
        this.canNext = false;
        this.canPrevious = false;
        this.nextScrollKey = '';
        this.scrollKeyList = [];
    }

    private disableControls(): void {
        this.canPrevious = false;
        this.canNext = false;
    }

    public updateScrollKey (scrollKey: string): void {
        if (scrollKey != null && scrollKey.length > 0) {
            this.canNext = true;
            this.nextScrollKey = scrollKey;
            this.scrollKeyList.push(scrollKey);
            this.canPrevious = this.scrollKeyList.length > 1;
        } else if (scrollKey === null && this.scrollKeyList.length > 0) {
            this.canNext = false;
            this.scrollKeyList.push('LAST');
            this.canPrevious = this.scrollKeyList.length > 1;
        }
    }

    ngOnDestroy(): void {
        this.reset();
    }
}
